let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1x5Vt")).then(() => parcelRequire('1qt4R'));